angular.module('main').filter(
	'cutString',
	() =>
		function(value, max) {
			if (!value) {
				return '';
			}
			if (value.length <= max) {
				return value;
			}
			value = value.substr(0, max);

			let lastSpace = value.lastIndexOf(' ');
			if (lastSpace !== -1) {
				if (
					value.charAt(lastSpace - 1) === '.' ||
					value.charAt(lastSpace - 1) === ',' ||
					value.charAt(lastSpace - 1) === '!' ||
					value.charAt(lastSpace - 1) === '?'
				) {
					lastSpace -= 1;
				}
				value = value.substr(0, lastSpace);
			}

			return `${value}...`;
		}
);



// WEBPACK FOOTER //
// ./web/js/services/filters/cutStringFilter.js